import {
  ChatMessageFormat,
  FakeChatMessageFormat,
} from 'types/enums/ChatMessageFormat';
import { ChatFollowUpMessage } from 'types/interfaces/chat/ChatFollowUpMessage';
import { ChatGiftMessage } from 'types/interfaces/chat/ChatGiftMessage';
import { ChatIcebreakerMessage } from 'types/interfaces/chat/ChatIcebreakerMessage';
import { ChatMatchIcebreakerMessage } from 'types/interfaces/chat/ChatMatchIcebreakerMessage';
import { ChatMatchMessage } from 'types/interfaces/chat/ChatMatchMessage';
import { ChatOfferLinkMessage } from 'types/interfaces/chat/ChatOfferLinkMessage';
import { ChatPhotoMessage } from 'types/interfaces/chat/ChatPhotoMessage';
import { ChatStickerMessage } from 'types/interfaces/chat/ChatStickerMessage';
import { ChatTextMessage } from 'types/interfaces/chat/ChatTextMessage';
import { ChatTransferLinkMessage } from 'types/interfaces/chat/ChatTransferLinkMessage';
import { ChatVideoMessage } from 'types/interfaces/chat/ChatVideoMessage';
import { ChatWantsChatMessage } from 'types/interfaces/chat/ChatWantsChatMessage';

import { Message } from 'api/DialogsApi';

export const assertTextMessage = (
  message: Message
): message is ChatTextMessage => {
  return message.format === ChatMessageFormat.Text;
};

export const assertPhotoMessage = (
  message: Message
): message is ChatPhotoMessage => {
  return message.format === ChatMessageFormat.Photo;
};

export const assertOfferLinkMessage = (
  message: Message
): message is ChatOfferLinkMessage => {
  return message.format === ChatMessageFormat.OfferLink;
};

export const assertTransferLinkMessage = (
  message: Message
): message is ChatTransferLinkMessage => {
  return message.format === ChatMessageFormat.TransferLink;
};

export const assertStickerMessage = (
  message: Message
): message is ChatStickerMessage => {
  return message.format === ChatMessageFormat.Sticker;
};

export const assertGiftMessage = (
  message: Message
): message is ChatGiftMessage => {
  return message.format === ChatMessageFormat.Gift;
};

export const assertVideoMessage = (
  message: Message
): message is ChatVideoMessage => {
  return message.format === ChatMessageFormat.Video;
};

export const assertMatchIcebreakerMessage = (
  message: Message
): message is ChatMatchIcebreakerMessage => {
  return message.format === ChatMessageFormat.MatchIcebreaker;
};

export const assertIcebreakerMessage = (
  message: Message
): message is ChatIcebreakerMessage => {
  return message.format === ChatMessageFormat.Icebreaker;
};

export const assertFollowUpMessage = (
  message: Message
): message is ChatFollowUpMessage => {
  return message.format === ChatMessageFormat.FollowUp;
};

export const assertWantsChatMessage = (
  message: Message
): message is ChatWantsChatMessage => {
  return message.format === ChatMessageFormat.WantsChat;
};

export const assertPerfectMatchMessage = (
  message: Message
): message is ChatMatchMessage => {
  return message.format === FakeChatMessageFormat.Match;
};

export const assertTextFormatMessage = (
  message: Message
): message is
  | ChatTextMessage
  | ChatMatchIcebreakerMessage
  | ChatIcebreakerMessage
  | ChatFollowUpMessage => {
  return (
    message.format === ChatMessageFormat.Text ||
    message.format === ChatMessageFormat.MatchIcebreaker ||
    message.format === ChatMessageFormat.Icebreaker ||
    message.format === ChatMessageFormat.FollowUp
  );
};
